import { useState, useEffect } from "react";
import { useAuth } from "../../../hooks/Auth";
import { RiEyeFill, RiEyeOffFill } from "react-icons/ri";
import { FiUnlock } from "react-icons/fi";
import LogoImage from "../../../assets/logo/logo-02.png";
import MonitoredEnvironment from "../../../components/monitoredEnvironment/MonitoredEnvironment";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const navigate = useNavigate();

  const { signAdmin, error } = useAuth();

  const [user, setUser] = useState({
    email: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;

    setUser((prevValue) => {
      return {
        ...prevValue,
        [name]: value
      };
    });
  }

  function handleTogglePassword() {
    setShowPassword(!showPassword);
  }

  const [loading, setLoading] = useState(false);

  async function handleWithSubmit(e) {
    e.preventDefault();
    setLoading(true); // Começa o carregamento

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!emailRegex.test(user.email)) {
      toast.warn("Formato de e-mail inválido", {
        position: toast.POSITION.TOP_RIGHT
      });
      setLoading(false); // Para o carregamento
      return;
    }

    if (user.email === "") {
      toast.warn("Insira o e-mail", { position: toast.POSITION.TOP_RIGHT });
      setLoading(false);
      return;
    }

    if (user.password === "") {
      toast.warn("Insira a senha", { position: toast.POSITION.TOP_RIGHT });
      setLoading(false);
      return;
    }

    await signAdmin(user);
    setLoading(false); // Finaliza o carregamento após o login
  }

  return (
    <>
      <ToastContainer />
      <MonitoredEnvironment />

      <div className="flex items-center justify-center  bg-gradient-to-b from-[#f2f2f2] to-[#fbf8f5] bg-cover bg-center">
        <div className="justify-center items-center self-center  h-screen ">
          <img
            src={LogoImage}
            alt="Logo"
            className="h-28 w-auto mx-auto mb-5 mt-20"
          />

          <div className="flex items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-[#a48f74]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
              />
            </svg>
            <input
              required
              onChange={handleChange}
              value={user.email}
              type="email"
              name="email"
              id="email"
              className="pl-2 bg-transparent   w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
              placeholder="email"
            />
          </div>
          <div className="flex items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-[#a48f74]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clipRule="evenodd"
              />
            </svg>
            <input
              required
              className="pl-2 bg-transparent  w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
              placeholder="senha"
              onChange={handleChange}
              value={user.password}
              type={showPassword ? "text" : "password"}
              name="password"
              id="password"
            />
            {showPassword ? (
              <RiEyeOffFill
                className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                onClick={handleTogglePassword}
              />
            ) : (
              <RiEyeFill
                className="h-5 w-5 text-[#a48f74] ml-2 cursor-pointer"
                onClick={handleTogglePassword}
              />
            )}
          </div>

          <button
            onClick={handleWithSubmit}
            className="w-full bg-[#6d7177] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center space-x-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                <span>Conectando...</span>
              </div>
            ) : (
              <>
                <FiUnlock className="mr-2" /> Acessar
              </>
            )}
          </button>

          <div className="flex flex-col space-y-2 mt-4">
            <button
              onClick={() => navigate("/recover-password")}
              className="w-full text-center text-gray-600 py-2 rounded-2xl border border-gray-200  "
            >
              Esqueceu sua senha?
            </button>
            <button
              onClick={() => navigate("/register")}
              className="w-full text-center bg-[#baa78e] bg-opacity-25 text-gray-600 py-2 rounded-2xl border border-gray-200"
            >
              Não tem conta? Cadastre-se
            </button>
          </div>
        </div>
      </div>
      {/* Rodapé */}
    </>
  );
}
